import {Button, Modal, Message} from "semantic-ui-react";

export const DeleteConfirmation = ({ open, setOpen, submitAction, loading, entityName = 'utility account', error }) => {
    return (
        <Modal
            open={open}
            onClose={() => setOpen(false)}
            size="tiny"
        >
            <Modal.Header>Are you sure you want to delete this {entityName}?</Modal.Header>
            {error && (
                <Modal.Content>
                    <Message negative content={error} />
                </Modal.Content>
            )}
            <Modal.Actions>
                <Button 
                    onClick={() => setOpen(false)}
                    disabled={loading}
                >
                    Cancel
                </Button>
                <Button 
                    className={'ui primary button'} 
                    onClick={submitAction}
                    loading={loading}
                >
                    Delete
                </Button>
            </Modal.Actions>
        </Modal>
    )
}